export default "__VITE_ASSET__e74d59b0__"